export default __webpack_public_path__ + "static/media/waze.42aec150.svg";